<template>
    <div class="section-subtitle">
        {{ label }}
        <form-tooltip-icon v-if="tooltip" size="24px">
            {{ tooltip }}
        </form-tooltip-icon>
    </div>
</template>

<script setup>
defineProps({
    label: String,
    tooltip: String,
})
</script>

<style>
.section-subtitle {
    font-size: 18px;
    margin-top: 40px;
}
</style>

